import useSWRImmutable from 'swr';
import { SWRResponse } from 'swr';
import { useMemo } from 'react';
import { apiGet } from 'packages/lib/api/annotations/rest';
import { sampleGroupsZod } from 'packages/lib/api/annotations/contract/sample-group';

/** Fetches a list of all Request IDs currently in the backend (by extracting them from all Sample Groups) */
export const useGetRequestIDs = (): Partial<
  SWRResponse<string[] | undefined>
> => {
  const {
    data: sampleGroups,
    error,
    isLoading,
  } = useSWRImmutable(
    '/sample-groups?requestId!=%null&pageSize=20000',
    (url: string) => apiGet(url, sampleGroupsZod.parse)
  );

  const requestIDs = useMemo(() => {
    if (!sampleGroups) return undefined;
    return [
      ...new Set(
        sampleGroups.flatMap((g) => (g.requestId ? [g.requestId] : []))
      ),
    ];
  }, [sampleGroups]);

  return { data: requestIDs, error, isLoading };
};
